



























import { Component, Prop, Mixins } from 'vue-property-decorator';
import { FormItem, Option, Select } from 'element-ui';

// Mixins
import places from '@/mixins/placeOptions';

// types
import {
  PortTypeEnum,
  ShipmentDocumentDataInput,
  ShipmentDocumentFields,
  TransportationCargoTypeEnum
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    'el-form-item': FormItem,
    'el-option': Option,
    'el-select': Select
  }
})
export default class CustomsLocation extends Mixins(places) {
  @Prop({ type: Object }) value!: ShipmentDocumentDataInput;
  @Prop({ type: Object }) document!: ShipmentDocumentFields;

  // places mixin option
  placeTypes = [PortTypeEnum.bonded_area];

  get customsLocation() {
    return this.value.customsLocation;
  }

  set customsLocation(data) {
    this.$emit('input', { ...this.value, customsLocation: data });
  }
}
